"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISerializedBoundaryConfigurationSchema = void 0;
const zod_1 = require("zod");
const SerializedBoundaryState_1 = require("./SerializedBoundaryState");
const IBoundaryInstance_1 = require("../DesignModels/IBoundaryInstance");
exports.ISerializedBoundaryConfigurationSchema = zod_1.default.object({
    netName: zod_1.default.string(),
    assertingBoundaries: IBoundaryInstance_1.BoundaryGlobalIdRefSchema.array(),
    connectedNets: zod_1.default.record(zod_1.default.string(), zod_1.default.string().array()),
    resolvedState: zod_1.default.lazy(() => SerializedBoundaryState_1.SerializedBoundaryStateSchema).optional(),
    hasResolvedState: zod_1.default.boolean(),
});
//# sourceMappingURL=ISerializedBoundaryConfiguration.js.map